import type { SVGProps } from 'react'
const SvgSyArrowLeftUpSystem = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path d="M4.3 6.3 21 23l2.3-2.3L6.7 4h12.6V.7H1v18.2h3.3z" />
	</svg>
)
export default SvgSyArrowLeftUpSystem
